import styled from 'styled-components';

export const Label = styled.span`
  font-size: 13px;
  line-height: 16px;
  margin-bottom: 12px;
  display: block;
`;

export const Answers = styled.div`
  row-gap: 10px;
  display: grid;
  margin-bottom: 14px;
`;

export const Answer = styled.div`
  column-gap: 12px;
  grid-template-columns: 1fr auto;
  display: grid;
`;
